import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, cloneElement, isValidElement } from 'react';
import { LeadButton } from './LeadButton';
const css = `
.lead-stack {
    position: fixed;
    right: 16px;
    bottom: 80px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
    z-index: 800;
    pointer-events: none;
    width: max-content;
    max-width: calc(100% - 32px);
}

.lead-stack > * {
    pointer-events: auto;
}

@media (max-width: 767px) {
    .lead-stack {
        left: 12px;
        right: 12px;
        bottom: 76px;
    }
}
@media (max-width: 767px) {
    .lead-stack {
        left: auto;
        right: 12px;
        width: calc(50% - 18px);
        bottom: 76px;
    }
}
`;
export function LeadStack({ children, pulse }) {
    let primaryApplied = false;
    const enriched = Children.map(children, (child) => {
        if (!isValidElement(child))
            return child;
        if (child.type !== LeadButton)
            return child;
        const variant = child.props.variant ?? 'primary';
        // Применяем pulse только к первой primary-кнопке
        if (variant === 'primary' && !primaryApplied) {
            primaryApplied = true;
            return cloneElement(child, { pulse });
        }
        // Все остальные кнопки — без pulse, даже если кто-то по ошибке передал
        return cloneElement(child, { pulse: false });
    });
    return (_jsxs(_Fragment, { children: [_jsx("style", { children: css }), _jsx("div", { className: "lead-stack", children: enriched })] }));
}
